export enum FileRecordQueryKey {
    FileRecordDetails = "file-record-details"
}
